export const CASHBACK_MIN_AMOUNT_FROM = 10000000;
export const CASHBACK_CONCEPT_AMOUNT = 200000;
export const REDEEM_CASHBACK_FEE_CATEGORY = 'discount';
export const REDEEM_CASHBACK_FEE_SUBCATEGORY = 'cashback';
export const REDEEM_CASHBACK_ = 'cashback';
export const CASHBACK_EARN_PERCENTAGE = 0.25;
